import './App.css';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CredibilitySection from './components/CredibilitySection';
import ServicesSection from './components/ServicesSection';
import IndustriesSection from './components/IndustriesSection';
import ProcessSection from './components/ProcessSection';
import DifferentiatorsSection from './components/DifferentiatorsSection';
import TeamSection from './components/TeamSection';
import CaseStudiesSection from './components/CaseStudiesSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <HeroSection />
        <CredibilitySection />
        <ServicesSection />
        <IndustriesSection />
        <ProcessSection />
        <DifferentiatorsSection />
        <TeamSection />
        <CaseStudiesSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
